import React, { useContext } from "react";
import InputsContext from "../contexts/InputsContext";
import { findInputs } from "../concerns/findInputs";

const ReturnButton = ({ lastStepInput }) => {
  const { inputs, setInputs } = useContext(InputsContext);
  const thisStepInputs = findInputs(inputs, inputs.currentIndex);

  const previousStep = () => {
    if (inputs.currentIndex > 0) {
      inputs.currentIndex -= 1;
      setInputs({ ...inputs });
    }
  };

  return (
    <div
      onClick={() => previousStep()}
      className={`px-8 py-6 w-60 flex items-center justify-center text-blueGray-500 text-xl font-bold cursor-pointer ${
        inputs.currentIndex === 0 ? "hidden" : "block"
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        />
      </svg>
      <span className="ml-2">Retour</span>
    </div>
  );
};

export default ReturnButton;
